import { Button, Page } from "@towersystems/roam-common-native";
import React, { useCallback, useEffect } from "react";
import { EnterCredentialsFieldset } from "../../components/Remove2faForm/components";
import { useFormContext, useWatch } from "react-hook-form";
import { Colors } from "react-native-ui-lib";
import { useRemove2faStrategy } from "../../../../utilities/2fa/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useFocusEffect } from "@react-navigation/native";
import { Remove2faFormValues } from "../../components/Remove2faForm/types";
import { useTranslation } from "../../../../utilities/i18n";

export const RemoveNative2faEnterCredentialsScreen = ({ navigation }: any) => {
  const { t } = useTranslation("settings");
  const { control, formState, handleSubmit, reset, getValues } =
    useFormContext<Remove2faFormValues>();

  const { isLoading, isSubmitting, isValid, isSubmitSuccessful } = formState;

  const disabled = isLoading || isSubmitting || !isValid || isSubmitSuccessful;

  const { handleOnSubmit } = useRemove2faStrategy();

  const codeSent = useWatch({ control, name: "ui.codeSent" });

  function handleComplete() {
    navigation.navigate("RemoveNative2faVerifyCodeScreen");
  }

  useEffect(() => {
    if (!codeSent) return;
    handleComplete();
  }, [codeSent]);

  // undo any form state from future steps if we come back to this screen
  // it also resets the isSubmitSuccessful flag on the form ready
  // for a new submission
  useFocusEffect(
    useCallback(() => {
      const values = getValues();
      reset({
        ui: {
          ...values.ui,
          codeSent: false,
        },
        data: {
          ...values.data,
          code: undefined,
        },
      });
    }, [reset])
  );

  const footerMarkup = (
    <Button
      disabled={disabled}
      label={t("button.remove_2fa_enter_credentials")}
      loading={isSubmitting}
      backgroundColor={Colors.action}
      color="white"
      onPress={handleSubmit(handleOnSubmit)}
    ></Button>
  );

  return (
    <Page
      title={t("title.remove_2fa_enter_credentials")}
      secondaryTitle={t("title.remove_2fa_enter_credentials_secondary")}
      footer={footerMarkup}
    >
      <EnterCredentialsFieldset />
    </Page>
  );
};
